import type { CustomAssessmentInput } from '@/shared/types/custom-assessment-input.types'

import { RetrofitRequiredField, getRetrofitRequiredField } from './retrofitFieldRequirements'

export enum AssessmentDataValidationError {
  NONE = 'NONE',
  NULL_DATA = 'NULL_DATA',
  ENERGY_PRICE_ERROR = 'ENERGY_PRICE_ERROR',
  RETROFIT_ERROR = 'RETROFIT_ERROR',
}

/**
 * Validates assessment data for energy prices and retrofits.
 * Returns an enum indicating where the error occurred, or NONE if valid.
 */
export const validateAssessmentData = (
  data: CustomAssessmentInput | null
): AssessmentDataValidationError => {
  if (!data) return AssessmentDataValidationError.NULL_DATA

  // Check if any energy price has errors
  const hasEnergyPriceErrors = data.energyPrices.some(price => !price.costs || price.costs <= 0)

  if (hasEnergyPriceErrors) {
    return AssessmentDataValidationError.ENERGY_PRICE_ERROR
  }

  // Check if any retrofit has errors
  const hasRetrofitErrors = data.retrofits.some(retrofit => {
    // Check totalCostsInCt is valid
    if (retrofit.totalCostsInCt && retrofit.totalCostsInCt < 0) return true

    // Validate the appropriate field based on retrofit type
    const requiredField = getRetrofitRequiredField(retrofit.retrofitName)

    if (requiredField === RetrofitRequiredField.POWER) {
      if (retrofit.powerInKw && retrofit.powerInKw < 0) return true
    } else if (requiredField === RetrofitRequiredField.AREA) {
      if (retrofit.componentAreaInSqm && retrofit.componentAreaInSqm < 0) return true
    }
    // NONE: no additional validation required

    return false
  })

  if (hasRetrofitErrors) {
    return AssessmentDataValidationError.RETROFIT_ERROR
  }

  return AssessmentDataValidationError.NONE
}
